import {
    FETCH_P24_RESTAURANT_CHEQUE_TRANSACTIONS,
    FILTER_P24_RESTAURANT_CHEQUE_TRANSACTIONS,
} from "./actionTypes";
import axios from "axios";
import {
    P24_RESTAURANT_CHEQUE_TRANSACTIONS_BY_FILTER_URL,
} from "../../config"
import { FILTER_DATE_FORMAT } from "../constants/dates"

/**
 * Pobieranie listy transakcji p24 dla podanej restauracji z serwera na podstawie filtra
 * 
 * @param {int} restaurantId identyfikator restauracji 
 * @param {Object} transactionFilter obiekt zawierajacy filtr
 */
export const fetchP24RestaurantChequeTransactionsByFilter = (restaurantId, transactionFilter) => {
    return dispatch => {
        return axios
            .get(P24_RESTAURANT_CHEQUE_TRANSACTIONS_BY_FILTER_URL(restaurantId), {
                params: {
                    startDate: transactionFilter.startDate.format(FILTER_DATE_FORMAT),
                    endDate: transactionFilter.endDate.format(FILTER_DATE_FORMAT),
                }
            })
            .then(response => {
                dispatch(fetchP24RestaurantChequeTransactionsSuccess(response.data));
            })
    }
}

/**
 * Ustawianie filtru transakcji rachunkowych dla restauracji
 * 
 * @param {Object} transactionFilter obiekt filtru
 */
export const filterP24RestaurantChequeTransactions = (transactionFilter) => {
    return dispatch => {
        dispatch(filterP24RestaurantChequeTransactionsSuccess(transactionFilter));
    }
}

/**
 * Akcja pomyślnego pobrania listy transakcji p24 
 * 
 * @param {object} data Obiekt pobranej listy transakcji
 */
const fetchP24RestaurantChequeTransactionsSuccess = data => {
    return {
        type: FETCH_P24_RESTAURANT_CHEQUE_TRANSACTIONS,
        payload: data
    };
};

/**
 * Akcja pomyślnego ustawienia filtru 
 * 
 * @param {object} data Obiekt filtru
 */
const filterP24RestaurantChequeTransactionsSuccess = data => {
    return {
        type: FILTER_P24_RESTAURANT_CHEQUE_TRANSACTIONS,
        payload: data
    };
};